import {component_tool, utils_tool} from '@/tool';
import React from 'react';
import moment from "moment";
import { WizTableForm } from '@/containers/common'

let {WizModal, WizSurveyAudience, WizTypography, WizRow, WizDataTable, WizButton, WizAlert} = component_tool;
let {$$, checkStrLength, Storage} = utils_tool;
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}
//配置项
let componentName = 'examPersonAuth'
const columns = ({type = null}, _this) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: "姓名",
      name: "fullNameSearch",
      searchItem: {},
    },
    {
      title: "账号",
      name: "userNameSearch",
      searchItem: {},
    },
    {
      title: '组织',
      name: 'orgIdList',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
      },
    },
    {
      title: '岗位',
      name: 'positionIdList',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
      },
    },
    {
      title: "任职状态",
      name: "jobState",
      searchItem: {
        type: "select"
      },
      dict: [
        {code: 0, codeName: '离职'},
        {code: 1, codeName: '在职'},
      ],
    },
    {
      title: "审核状态",
      name: "status",
      searchItem: {
        type: "select"
      },
      dict: [
        {code: 2, codeName: '待审核'},
        {code: 4, codeName: '审核未通过'},
        {code: 3, codeName: '审核通过'},
        {code: 1, codeName: '系统审核通过'},
        {code: 5, codeName: '未认证'},
      ]
    },
    {
      title: "姓名",
      name: "fullName",
      tableItem: {
        width: 100,
      },
    },
    {
      title: "账号",
      name: "userName",
      tableItem: {
        width: 100,
      },
    },
    {
      title: "手机号",
      name: "mobile",
      tableItem: {
        width: 100,
      },
    },
    {
      title: "组织名称",
      name: "orgName",
      tableItem: {
        width: 180,
      },
    },
    {
      title: "组织编码",
      name: "orgCode",
      tableItem: {
        width: 120,
      },
    },
    {
      title: "岗位",
      name: "positionName",
      tableItem: {
        width: 100,
      },
    },
    {
      title: "任职状态",
      name: "jobState",
      tableItem: {
        width: 80,
      },
      dict: [
        {code: 0, codeName: '离职'},
        {code: 1, codeName: '在职'},
      ]
    },
    {
      title: "考试场次",
      name: "examPaperOrder",
      tableItem: {
        width: 80,
        render: (text, record) => {
          const {examPaperOrder, count} = record;
          return `${examPaperOrder}/${count === 0 ? '无限制' : count}`
        }
      },
    },
    {
      title: "参考时间",
      name: "startDate",
      tableItem: {
        width: 300,
        render: (text, record) => {
          const {startDate, endDate} = record;
          return formatterDate(startDate) + ' - ' + formatterDate(endDate)
        }
      },
    },
    {
      title: "认证次数",
      name: "faceCurrentTimes",
      tableItem: {
        width: 80,
      },
    },
    {
      title: "失败次数",
      name: "roundTimes",
      tableItem: {
        width: 80,
      },
    },
    {
      title: "审核状态",
      name: "status",
      tableItem: {
        width: 100,
      },
      dict: [
        {code: 0, codeName: '考试进行中'},
        {code: 1, codeName: '系统审核通过'},
        {code: 2, codeName: '待审核'},
        {code: 3, codeName: '审核通过'},
        {code: 4, codeName: '审核未通过'},
        {code: 5, codeName: '未认证'},
      ]
    },

    {
      title: '审核意见',
      name: 'auditInfo',
      tableItem: {},
    }
  ];
}

const templateConfig = (id, _this, data) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns({}, _this),
        searchBarProps: {
          // cols: {
          //   xs: 24,
          //   md: 12,
          //   xl: 8
          // },
          buttonSort: ['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          loading: false,
          bordered: false
        },
        rowOperateProps: {
          width: 220
        },
        rowOperateSort: ['look', 'review'],
        rowOperateView: [
          {
            key: 'look',//考试人脸记录
            custom: true,
            params: {children: '查看'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                  pathname: '/online/examRecord/examPersonAuthLook'
              }
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = false;
              let hidden = false;
              if (!record || (record.status === null || record.status === undefined || record.status === 5)) {
                disabled = true;
                hidden = true;
              }
              return {disabled: disabled, hidden}
            }
          },
          {
            key: 'review',
            custom: true,
            params: {children: '审核'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/online/examRecord/examPersonAuthAudit'
              }
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = true;
              let hidden = true;
              if (record && (record.status != null && record.status != undefined && record.status === 2)) {
                disabled = false;
                hidden = false;
              }
              return {disabled: disabled, hidden}
            }
          },
        ],
        commonOperate: {}
      }
    }
  }
};

const apis = (record) => {
  const {id, title} = record;
  return {
    list: {
      path: `${componentName}/pageList`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: {pageNum: 1, pageSize: 10, examName: title, examId: id, unStatusList: [0]}
      }
    },
    export: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@getList`,
        apiParams: {pageNum: 1, pageSize: 10, examName: title, examId: id, unStatusList: [0]}
      }
    }
  }
}


let reduxTemplateCofig = (args) => {
  const {record} = args;
  return {
    apis: apis(record),
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
